/** Причина потери сессии. */
export type SessionLostReason = "token-expired" | "token-check-failed" | "unauthorized";

/** Событие потери сессии. */
export interface SessionLostEvent {
    reason: SessionLostReason;
    source?: string;
    code?: number;
}

type SessionLostHandler = (event: SessionLostEvent) => void;

const handlers = new Set<SessionLostHandler>();
let lastEmitAt = 0;

/** Окно дедупликации session-lost (мс). */
export const SESSION_LOST_DEDUPE_MS = 2000;

/**
 * Подписывается на потерю сессии.
 * @returns функция отписки
 */
export function subscribeSessionLost(handler: SessionLostHandler): () => void {
    handlers.add(handler);
    return () => {
        handlers.delete(handler);
    };
}

/**
 * Сообщает приложению о потере сессии (без UI и redirect — это делает provider).
 */
export function emitSessionLost(event: SessionLostEvent): void {
    const now = Date.now();
    if (now - lastEmitAt < SESSION_LOST_DEDUPE_MS) {
        return;
    }
    lastEmitAt = now;

    for (const handler of handlers) {
        handler(event);
    }
}

/** Код Omega REST: истёкший токен авторизации. */
export const OMEGA_TOKEN_EXPIRED_CODE = 2005;
